'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _commondrgchanges = require('./commondrgchanges.html');

var _commondrgchanges2 = _interopRequireDefault(_commondrgchanges);

var _commondrgchanges3 = require('./commondrgchanges.controller');

var _commondrgchanges4 = _interopRequireDefault(_commondrgchanges3);

require('./commondrgchanges.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var commondrgchangesComponent = {
  restrict: 'E',
  bindings: {},
  template: _commondrgchanges2.default,
  controller: _commondrgchanges4.default,
  controllerAs: 'vm'
};

exports.default = commondrgchangesComponent;


// WEBPACK FOOTER //
// ./client/app/common/reports/commondrgchanges/commondrgchanges.component.js